<div class="value">{{caption}}</div>
